module.exports = __webpack_public_path__ + "img/japan-external-causes-female.4c34d9c5.png";